import React, { useState, useEffect, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Tooltip, Drawer, List, ListItem, ListItemIcon, ListItemText, Divider, Chip } from '@mui/material';
import { MenuItem, Select, FormControl, InputLabel, createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import IconButton from '@mui/material/IconButton';
import { Radio, RadioGroup } from "@mui/material";

import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@material-ui/core/TextField';
import RefreshIcon from '@mui/icons-material/Refresh';
import Cookies from 'js-cookie';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@mui/material/AppBar';
import Box from '@material-ui/core/Box';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { useParams } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import { styled } from '@material-ui/styles';
import { Card, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CheckIcon from '@mui/icons-material/Check';
import DescriptionIcon from '@mui/icons-material/Description';
import CancelIcon from '@mui/icons-material/Cancel';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TimelineRonda from './components/TimelineRonda';
import LogInterativoRonda from './components/LogInterativoRonda';

// Ícones para o Menu Lateral
import InfoIcon from '@mui/icons-material/Info';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import HistoryIcon from '@mui/icons-material/History';
import MapIcon from '@mui/icons-material/Map';
import BusinessIcon from '@mui/icons-material/Business';
import RoomIcon from '@mui/icons-material/Room';

import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import {
    DataGrid,  
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import { ptBR } from '@mui/x-data-grid/locales';
import { AddToQueueOutlined, LaptopWindows } from '@material-ui/icons';


const drawerWidth = 260;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: props => props.darkMode ? '#1e1e1e' : '#fff',
        color: props => props.darkMode ? '#fff' : '#000',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
        backgroundColor: props => props.darkMode ? '#1a1a1a' : '#fff',
        color: props => props.darkMode ? '#fff' : '#000',
        borderRight: props => props.darkMode ? '1px solid #333' : '1px solid #ddd',
    },
    drawerContainer: {
        overflow: 'auto',
        marginTop: 0, // In editorOrdemServico pattern, the AppBar is often static or the Drawer starts below it if desired. 
                        // But user specifically said "abaixo do navegador de gestão".
    },
    sidebarHeader: {
        padding: theme.spacing(3),
        backgroundColor: props => props.darkMode ? '#222' : '#f8f9fa',
        borderBottom: props => props.darkMode ? '1px solid #333' : '1px solid #eee',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        backgroundColor: props => props.darkMode ? '#121212' : '#f5f5f5',
        minHeight: '100vh',
    },
    toolbar: theme.mixins.toolbar,
    paper: {
        padding: theme.spacing(3),
        borderRadius: 12,
        backgroundColor: props => props.darkMode ? '#1e1e1e' : '#fff',
    },
    tabPanel: {
        marginTop: theme.spacing(2),
    },
    sidebarItem: {
        margin: '8px 12px',
        borderRadius: 8,
        '&.Mui-selected': {
            backgroundColor: 'rgba(33, 150, 243, 0.15)',
            color: '#2196f3',
            '& .MuiListItemIcon-root': {
                color: '#2196f3',
            },
        },
    }
}));

const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'transparent',
    '&:hover': {
        backgroundColor: '#cc0000',
    },
}));

const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: '#4caf50',
    '&:hover': {
        backgroundColor: '#388e3c',
    },
}));

const ColorButtonBlue = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: '#2196f3',
    '&:hover': {
        backgroundColor: '#1976d2',
    },
}));









export default function GerenciarRondaMotorizada() {


    const [darkMode, setDarkMode] = useState(Cookies.get('darkMode') === 'true');
    const classes = useStyles({ darkMode });
    const history = useHistory();

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const handleDarkModeChange = () => {
            setDarkMode(Cookies.get('darkMode') === 'true');
        };

        window.addEventListener('darkModeChanged', handleDarkModeChange);

        return () => {
            window.removeEventListener('darkModeChanged', handleDarkModeChange);
        };
    }, []);

    const theme = createTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            ...(darkMode && {
                background: {
                    default: '#121212',
                    paper: '#1e1e1e',
                },
                text: {
                    primary: '#fff',
                    secondary: '#ccc',
                },
            }),
        },
    });

    const [rondaMotorizada, setRondaMotorizada] = useState();
    const { idRondaMotorizada } = useParams();

    const [inSalvamento, setInSalvamento] = useState(false);
    const [instalacaoSelecionada, setInstalacaoSelecionada] = useState(null);

    const [logs, setLogs] = useState([]);
    const [loadingLogs, setLoadingLogs] = useState(true);

    async function listarLogs() {
        try {
            const token = Cookies.get('token');
            const headers = {
                'Authorization': 'Bearer ' + token
            }
            const response = await api.get("/v1/protected/rondamotorizada/log/listarporronda/" + idRondaMotorizada, {
                headers: headers
            });
            console.log("Logs response: ", response.data);
            setLogs(response.data || []);
            setLoadingLogs(false);
        } catch (err) {
            console.error("Erro ao listar logs: ", err);
            setLoadingLogs(false);
        }
    }


    async function listarInformacoes() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("/v1/protected/rondamotorizada/listarporid/" + idRondaMotorizada, {
                headers: headers
            }).then(function (response) {

                console.log(JSON.stringify(response.data));

                setRondaMotorizada(response.data);
                setInstalacaoSelecionada(response.data.instalacao);
                setLoading(false);
            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }



    const [elapsedTime, setElapsedTime] = useState("");

    const fixDateArray = (dateInput) => {
        if (Array.isArray(dateInput)) {
            // Jackson sends [YYYY, MM, DD, HH, mm, ss] where MM is 1-indexed.
            // Moment constructor with array expects 0-indexed month.
            const fixedDate = [...dateInput];
            if (fixedDate.length > 1) fixedDate[1] = fixedDate[1] - 1; 
            return moment(fixedDate);
        }
        return moment(dateInput);
    };

    useEffect(() => {
        listarInformacoes();
        listarLogs();
    }, [idRondaMotorizada]);

    useEffect(() => {
        const timer = setInterval(() => {
            if (rondaMotorizada && rondaMotorizada.data_hora_criacao) {
                const startTime = fixDateArray(rondaMotorizada.data_hora_criacao);
                setElapsedTime(moment.duration(moment().diff(startTime)).humanize());
            }
        }, 60000); // Update every minute

        return () => clearInterval(timer);
    }, [rondaMotorizada]);




    function novoProcedimento(etapaProcedimento) {

        if (parseInt(rondaMotorizada.usuario_executor.id_usuario, 10) === parseInt(Cookies.get("id_usuario"), 10)) {

            window.location.href = "/gestao/operacional/rondamotorizada/cadastrarprocedimentoavulso/" + idRondaMotorizada;

        } else {
            alert("Somente o usuário executor da Ronda Motorizada pode executar esta ação!");
            return;
        }

    }




    const handleClickAtualizarProcedimento = (procedimento) => {

        if (parseInt(rondaMotorizada.usuario_executor.id_usuario, 10) === parseInt(Cookies.get("id_usuario"), 10)) {

            window.location.href = "/gestao/operacional/rondamotorizada/atualizarprocedimentoexecucao/" + procedimento.id_procedimento_execucao + "/rondamotorizada/" + rondaMotorizada.id_ronda_motorizada + "/0";

        } else {
            alert("Somente o usuário executor da Ronda Motorizada pode executar esta ação!");
            return;
        }

    };


    const handleClickVizualizarProcedimento = (procedimento) => {
        // window.open(`/gestao/operacional/rondamotorizada/vizualizarprocedimentoexecucao/${id}`, '_blank');
        window.location.href = "/gestao/operacional/rondamotorizada/atualizarprocedimentoexecucao/" + procedimento.id_procedimento_execucao + "/rondamotorizada/" + rondaMotorizada.id_ronda_motorizada + "/1";

    };



    async function handleClickIniciarProcedimento(id) {

        if (parseInt(rondaMotorizada.usuario_executor.id_usuario, 10) === parseInt(Cookies.get("id_usuario"), 10)) {

            const resposta = window.confirm("Sinalizar inicio da execução do procedimento?");

            if (resposta) {
                console.log(`Procedimento com ID ${id} iniciado.`);
                try {

                    const cadastro = {
                        usuario_criador: { id_usuario: Cookies.get("id_usuario") },
                    }
                    const headers = {
                        'Authorization': 'Bearer ' + Cookies.get("token")
                    }
                    const response = await api.put('/v1/protected/rondamotorizada/atualizarprocedimentoexecucao/iniciarprocedimento/' + id + "/" + idRondaMotorizada, cadastro,
                        { headers: headers });

                    const cadastro_salvo = response.data;
                    if (cadastro_salvo) {
                        alert("Procedimento foi sinalizado como iniciado!");
                        listarInformacoes();
                    } else {
                        alert("Erro de Conexão, tente novamente mais tarde");
                    }


                } catch (_err) {
                    console.log("erro ao cadastrar: " + _err);
                    alert("Erro de Conexão, tente novamente mais tarde");

                }

            } else {
                return;
            }
        } else {
            alert("Somente o usuário executor da Ronda Motorizada pode executar esta ação!");
            return;
        }
    };

    const [mensagemCancelamento, setMensagemCancelamento] = useState("");
    const [openCancelarProcedimento, setOpenCancelarProcedimento] = useState(false);
    const [idProcedimentoCancelar, setIdProcedimentoCancelar] = useState(false);

    const handleCloseCancelarProcedimento = () => {
        setMensagemCancelamento("");
        setIdProcedimentoCancelar(0);
        setOpenCancelarProcedimento(false); // assumindo que você tem um estado chamado 'open' para controlar a abertura do diálogo
    };




    function handleClickOpenCancelarProcedimento(id) {

        if (parseInt(rondaMotorizada.usuario_executor.id_usuario, 10) === parseInt(Cookies.get("id_usuario"), 10)) {
            setMensagemCancelamento("");
            setIdProcedimentoCancelar(id);
            setOpenCancelarProcedimento(true);

        } else {
            alert("Somente o usuário executor da Ronda Motorizada pode executar esta ação!");
            return;
        }
    };

    async function handleClickCancelarProcedimento() {
        if (parseInt(rondaMotorizada.usuario_executor.id_usuario, 10) === parseInt(Cookies.get("id_usuario"), 10)) {
            const resposta = window.confirm("Confirmar cancelamento do procedimento?");

            if (resposta) {
                console.log(`Procedimento com ID ${idProcedimentoCancelar} cancelado.`);
                try {

                    const cadastro = {
                        mensagem_cancelamento: mensagemCancelamento,
                    }
                    const headers = {
                        'Authorization': 'Bearer ' + Cookies.get("token")
                    }
                    const response = await api.put('/v1/protected/rondamotorizada/cancelarprocedimentorondamotorizada/' + idProcedimentoCancelar + "/" + idRondaMotorizada, cadastro,
                        { headers: headers });

                    const cadastro_salvo = response.data;
                    if (cadastro_salvo) {
                        alert("Procedimento foi cancelado!");
                        handleCloseCancelarProcedimento();
                        listarInformacoes();
                    } else {
                        alert("Erro de Conexão, tente novamente mais tarde");
                    }


                } catch (_err) {
                    console.log("erro ao cadastrar: " + _err);
                    alert("Erro de Conexão, tente novamente mais tarde");

                }

            } else {
                return;
            }

        } else {
            alert("Somente o usuário executor da Ronda Motorizada pode executar esta ação!");
            return;
        }
    };


    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {

        setValue(newValue);

    }


    const handleChangeIndex = (index) => {
        setValue(index);
    };



    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }



    function returnDescricaoInstalacao(instalacao) {
        var texto = "SIGMA: " + instalacao.identificador_integrador + "\n Instalacao_ID: " + instalacao.id_instalacao + "\n CPF/CNPJ: " + (instalacao.tipo_instalacao === 0 ? instalacao.cpf : instalacao.cnpj) +
            "\n Nome/Nome Fantasia: " + (instalacao.tipo_instalacao === 0 ? (instalacao.nome + " " + instalacao.sobrenome) : instalacao.nome_fantasia);

        return texto;
    }



    const [openTratamentoRemoto, setOpenTratamentoRemoto] = useState(false);
    const [observacoesEncerramentoRonda, setObservacoesEncerramentoRonda] = useState("");

    const [criarOrdemServico, setCriarOrdemServico] = useState(false);
    const [disableOpcaoOrdemServico, setDisableOpcaoOrdemServico] = useState(false);

    const verificarProcedimentosObrigatorios = () => {
        return rondaMotorizada.procedimentos.some((procedimentoExecucao) => {
            return procedimentoExecucao.procedimento.obrigatorio === 1 && procedimentoExecucao.status === 0;
        });
    };

    async function handleOpenRondaMotorizada() {


        const result = verificarProcedimentosObrigatorios();
        if (result) {
            alert("Existem Procedimentos Obrigatórios Pendentes, atualize-os!")
        } else {
            //verificar se existem problemas
            const hasProblemas = rondaMotorizada.procedimentos.some(procedimento => procedimento.problemas.length >= 1);

            if (hasProblemas) {
                setCriarOrdemServico(true);
                setDisableOpcaoOrdemServico(true);
            } else {
                setDisableOpcaoOrdemServico(false);
                setCriarOrdemServico(false);
            }
            setOpenTratamentoRemoto(true);

        }
    }


    const handleCloseTratamentoRemoto = () => {
        setObservacoesEncerramentoRonda("");
        setOpenTratamentoRemoto(false);
    };

    async function handleFinalizarRondaMotorizada() {
        if (parseInt(rondaMotorizada.usuario_executor.id_usuario, 10) === parseInt(Cookies.get("id_usuario"), 10)) {
            setInSalvamento(true);
            try {
                const cadastro = {
                    observacoes_encerramento_ronda: observacoesEncerramentoRonda,
                    criar_ordem_servico: criarOrdemServico ? 1 : 0,
                }
                const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") }
                const response = await api.put('/v1/protected/rondamotorizada/finalizarrondamotorizada/' + idRondaMotorizada, cadastro, { headers: headers });
                if (response.data) {
                    alert("A Ronda Motorizada foi atualizada!");
                    setInSalvamento(false);
                    window.location.reload(true);
                }
            } catch (_err) {
                setInSalvamento(false);
                alert("Erro de Conexão, tente novamente mais tarde");
            }
        } else {
            alert("Somente o usuário executor da Ronda Motorizada pode executar esta ação!");
            setInSalvamento(false);
        }
    }

    async function handleBalaoOk() {
        try {
            var url = "v1/protected/rondamotorizada/verificarpendente/" + parseInt(rondaMotorizada.id_ronda_motorizada, 10);
            await api.get(url).then(function (response) {
                if (response.data === "ronda_nula") {
                    alert("Ronda não mais listada no sistema!");
                    listarInformacoes();
                } else if (response.data === "disponivel") {
                    const token = Cookies.get('token');
                    const headers = { 'Authorization': 'Bearer ' + token }
                    const cadastro = { usuario_executor: { id_usuario: Cookies.get("id_usuario") } }
                    api.put("/v1/protected/rondamotorizada/assumirrondamotorizada/" + rondaMotorizada.id_ronda_motorizada + "/" + Cookies.get("id_usuario"), cadastro, { headers: headers }).then(function (response) {
                        if (parseInt(response.data.usuario_executor.id_usuario) === parseInt(Cookies.get("id_usuario"), 10)) {
                            alert("Ronda Motorizada assumida por você");
                            listarInformacoes();
                        } else {
                            alert("Erro, consulte o administrador");
                            listarInformacoes();
                        }
                    });
                } else {
                    alert("Usuário " + response.data + " já assumiu a execução dessa ronda motorizada");
                    listarInformacoes();
                }
            });
        } catch (_err) {
            console.log("Erro ao assumir ronda: " + _err);
        }
    }

    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (index) => {
        setTabValue(index);
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }

    const logColumns = [
        { field: 'id_log_ronda_motorizada', headerName: 'ID', width: 90 },
        { 
            field: 'data_hora', 
            headerName: 'Data/Hora', 
            width: 180, 
            renderCell: (params) => {
                const dateArr = params.value;
                if (Array.isArray(dateArr)) {
                    const fixedDate = [...dateArr];
                    if (fixedDate.length > 1) fixedDate[1] = fixedDate[1] - 1;
                    return moment(fixedDate).format('DD/MM/YYYY HH:mm:ss');
                }
                return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
            }
        },
        { field: 'tipo', headerName: 'Tipo', width: 220 },
        { field: 'descricao', headerName: 'Descrição', flex: 1, minWidth: 300 },
    ];

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor={darkMode ? '#121212' : '#f5f5f5'}>
                <Skeleton variant="rect" width="100%" height="100vh" />
            </Box>
        );
    }

    const drawerContent = (
        <div className={classes.drawerContainer}>
            <Box className={classes.sidebarHeader}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    item xs={12}
                    style={{ width: '100%', margin: 0, padding: 0 }}
                >
                    <a href="/gestao/operacional/rondamotorizada/listar" style={{ fontSize: 13, color: darkMode ? '#2196f3' : '#2196f3', marginRight: '5px', textDecoration: 'none', fontWeight: 600 }}>
                        {"< Rondas - "}
                    </a>
                    <Typography variant="subtitle2" style={{ fontWeight: 800, color: darkMode ? '#fff' : '#444', textTransform: 'uppercase', letterSpacing: 1, fontSize: 13 }}>
                        DETALHES
                    </Typography>
                </Grid>
            </Box>

            <Box p={3}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="caption" color="textSecondary" style={{ fontWeight: 700, textTransform: 'uppercase' }}>Instalação</Typography>
                        <Typography variant="body2" style={{ fontWeight: 600, color: darkMode ? '#fff' : '#444' }}>
                            {instalacaoSelecionada?.nome_fantasia || instalacaoSelecionada?.razao_social || "N/A"}
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="caption" color="textSecondary" style={{ fontWeight: 700, textTransform: 'uppercase' }}>Criador</Typography>
                        <Typography variant="body2" style={{ fontWeight: 600, color: darkMode ? '#fff' : '#444' }}>
                            {rondaMotorizada?.usuario_criador?.nome_amigavel || "Sistema"}
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="caption" color="textSecondary" style={{ fontWeight: 700, textTransform: 'uppercase' }}>Executor Escolhido</Typography>
                        <Typography variant="body2" style={{ fontWeight: 600, color: darkMode ? '#fff' : '#444' }}>
                            {rondaMotorizada?.usuario_executor?.nome_amigavel || "Pendente"}
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="caption" color="textSecondary" style={{ fontWeight: 700, textTransform: 'uppercase' }}>Criação</Typography>
                        <Typography variant="body2" style={{ fontWeight: 600, color: darkMode ? '#fff' : '#444' }}>
                            {rondaMotorizada?.data_hora_criacao ? fixDateArray(rondaMotorizada.data_hora_criacao).format("DD/MM/YYYY HH:mm") : "-"}
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="caption" color="textSecondary" style={{ fontWeight: 700, textTransform: 'uppercase' }}>Tempo Decorrido</Typography>
                        <Typography variant="body2" style={{ fontWeight: 600, color: '#2196f3' }}>
                            {elapsedTime || "Calculando..."}
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="caption" color="textSecondary" style={{ fontWeight: 700, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Status Atual</Typography>
                        <span style={{ 
                            padding: '4px 10px', 
                            borderRadius: 12, 
                            fontSize: 11, 
                            fontWeight: 800,
                            backgroundColor: Number(rondaMotorizada?.status_ronda_motorizada) === 10 ? '#4caf5022' : (Number(rondaMotorizada?.status_ronda_motorizada) === 1 ? '#2196f322' : '#ff980022'),
                            color: Number(rondaMotorizada?.status_ronda_motorizada) === 10 ? '#4caf50' : (Number(rondaMotorizada?.status_ronda_motorizada) === 1 ? '#2196f3' : '#ff9800'),
                            border: `1px solid ${Number(rondaMotorizada?.status_ronda_motorizada) === 10 ? '#4caf50' : (Number(rondaMotorizada?.status_ronda_motorizada) === 1 ? '#2196f3' : '#ff9800')}`
                        }}>
                            {Number(rondaMotorizada?.status_ronda_motorizada) === 10 ? 'FINALIZADA' : (Number(rondaMotorizada?.status_ronda_motorizada) === 1 ? 'CONCLUÍDA' : 'EM ANDAMENTO')}
                        </span>
                    </Grid>
                </Grid>
            </Box>

            <Divider style={{ borderColor: darkMode ? '#333' : '#eee', margin: '8px 0' }} />
            
         
        </div>
    );

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <div className={classes.root}>
                <AppBar position="fixed" className={classes.appBar} elevation={0} style={{ borderBottom: darkMode ? '1px solid #333' : '1px solid #eee' }}>
                    <NavegadorGestao
                        Operacional={true}
                        RondaMotorizada={true}
                        corFundo={darkMode ? '#1e1e1e' : 'white'} 
                        travado={true} 
                        corTexto={darkMode ? 'white' : 'black'}
                    />
                </AppBar>

                <Drawer
                    className={classes.drawer}
                    variant="permanent"
                    classes={{ paper: classes.drawerPaper }}
                    PaperProps={{ style: { marginTop: 64 } }}
                >
                    {drawerContent}
                </Drawer>

                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    
                    <Box style={{ backgroundColor: darkMode ? '#1e1e1e' : 'white', width: '100%', borderRadius: 8, marginBottom: 20, boxShadow: darkMode ? '0 4px 20px rgba(0,0,0,0.5)' : '0 2px 10px rgba(0,0,0,0.05)' }}>
                        <AppBar position="static" color="default" elevation={0} style={{ backgroundColor: 'transparent', borderBottom: darkMode ? '1px solid #333' : '1px solid #eee', borderRadius: 8 }}>
                            <Tabs
                                value={tabValue}
                                onChange={(e, v) => handleTabChange(v)}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons="auto"
                                style={{ minHeight: 48 }}
                            >
                                <Tab label="Informações Iniciais" style={{ color: tabValue === 0 ? '#2196f3' : (darkMode ? '#aaa' : '#666'), fontWeight: tabValue === 0 ? 800 : 500 }} />
                                <Tab label="Logs de Auditoria" style={{ color: tabValue === 1 ? '#2196f3' : (darkMode ? '#aaa' : '#666'), fontWeight: tabValue === 1 ? 800 : 500 }} />
                            </Tabs>
                        </AppBar>
                    </Box>
                    <Container maxWidth="xl" className={classes.tabPanel}>
                        {tabValue === 0 && (
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Paper className={classes.paper} elevation={0}>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                            <Typography variant="h5" style={{ fontWeight: 700, color: darkMode ? '#fff' : 'inherit' }}>Informações Iniciais</Typography>
                                            {Number(rondaMotorizada?.status_ronda_motorizada) !== 10 && Number(rondaMotorizada?.status_ronda_motorizada) !== 1 && (
                                                <Box display="flex" gap={2}>
                                                    {!rondaMotorizada.usuario_executor && (
                                                        <ColorButtonBlue onClick={handleBalaoOk} startIcon={<CheckCircleIcon />} variant="contained" style={{ borderRadius: 8 }}>
                                                            Assumir Ronda
                                                        </ColorButtonBlue>
                                                    )}
                                                    <ColorButtonGreen onClick={handleOpenRondaMotorizada} startIcon={<DoneAllIcon />} variant="contained" style={{ borderRadius: 8 }}>
                                                        Finalizar Ronda
                                                    </ColorButtonGreen>
                                                </Box>
                                            )}
                                        </Box>
                                        <Divider style={{ margin: '15px 0', borderColor: darkMode ? '#333' : '#eee' }} />
                                        
                                        <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 700, color: darkMode ? '#ccc' : '#666', textTransform: 'uppercase' }}>
                                            Descrição / Observações da Solicitação
                                        </Typography>
                                        <Box p={2} style={{ backgroundColor: darkMode ? '#252525' : '#f9f9f9', borderRadius: 8, border: darkMode ? '1px solid #333' : '1px solid #eee' }}>
                                            <Typography variant="body1" style={{ color: darkMode ? '#eee' : '#333', whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
                                                {rondaMotorizada?.descricao || "Nenhuma descrição adicional informada para esta ronda."}
                                            </Typography>
                                        </Box>

                                        {(Number(rondaMotorizada?.status_ronda_motorizada) === 10 || Number(rondaMotorizada?.status_ronda_motorizada) === 1) && (
                                            <Box mt={4}>
                                                <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 700, color: '#4caf50', textTransform: 'uppercase' }}>
                                                    Desfecho / Observações do Encerramento
                                                </Typography>
                                                <Box p={2} style={{ backgroundColor: darkMode ? '#1b2e1b' : '#f1f8f1', borderRadius: 8, border: '1px solid #4caf5044' }}>
                                                    <Typography variant="body1" style={{ color: darkMode ? '#dfd' : '#2e7d32', whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
                                                        {rondaMotorizada?.observacoes_encerramento_ronda || "Ronda encerrada sem observações finais."}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        )}
                                        <Box mt={4}>
                                            <TimelineRonda 
                                                ronda={rondaMotorizada} 
                                                darkMode={darkMode} 
                                            />
                                        </Box>
                                        <Box mt={4}>
                                            <LogInterativoRonda 
                                                rondaId={idRondaMotorizada} 
                                                darkMode={darkMode} 
                                            />
                                        </Box>

                                        {/* EXIBIÇÃO DE QUESTIONÁRIO E PROBLEMAS (MOVIDO) */}
                                        {rondaMotorizada?.procedimentos?.map((proc) => (
                                            <Box key={proc.id_procedimento_execucao} mt={5}>
                                                <Typography variant="h6" style={{ fontWeight: 700, marginBottom: 15, color: darkMode ? '#90caf9' : '#1976d2' }}>
                                                    {proc.procedimento.nome}
                                                </Typography>
                                                
                                                {/* Questões */}
                                                {proc.questao_resposta && proc.questao_resposta.length > 0 && (
                                                    <Box mb={4}>
                                                        <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 700, color: darkMode ? '#aaa' : '#666', textTransform: 'uppercase', marginBottom: 10 }}>Questionário</Typography>
                                                        <Grid container spacing={2}>
                                                            {proc.questao_resposta.map((q) => (
                                                                <Grid item xs={12} md={6} key={q.id_questao_resposta}>
                                                                    <Box p={2} style={{ borderRadius: 10, border: darkMode ? '1px solid #333' : '1px solid #eee', backgroundColor: darkMode ? 'rgba(255,255,255,0.02)' : '#fafafa' }}>
                                                                        <Typography variant="caption" color="textSecondary" style={{ display: 'block', fontWeight: 600, marginBottom: 4 }}>{q.nome}</Typography>
                                                                        <Typography variant="body2" style={{ fontWeight: 700, color: darkMode ? '#fff' : '#444' }}>
                                                                            {q.tipo === 1 ? (q.escolha_fixa === 1 ? "SIM" : "NÃO") : (q.resposta_livre || "Sem resposta")}
                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    </Box>
                                                )}

                                                {/* Problemas */}
                                                {proc.problemas && proc.problemas.length > 0 && (
                                                    <Box>
                                                        <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 700, color: '#f44336', textTransform: 'uppercase', marginBottom: 10 }}>Problemas Identificados</Typography>
                                                        <Box display="flex" flexWrap="wrap" gap={1}>
                                                            {proc.problemas.map((p) => (
                                                                <Chip key={p.id_problema} label={p.nome} color="error" variant="outlined" style={{ fontWeight: 600 }} />
                                                            ))}
                                                        </Box>
                                                    </Box>
                                                )}
                                            </Box>
                                        ))}
                                    </Paper>
                                </Grid>
                            </Grid>
                        )}

                        {tabValue === 1 && (
                            <Paper className={classes.paper} elevation={0}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                    <Typography variant="h5" style={{ fontWeight: 700, color: darkMode ? '#fff' : 'inherit' }}>Histórico de Atividades</Typography>
                                    <IconButton onClick={listarLogs} color="primary">
                                        <RefreshIcon />
                                    </IconButton>
                                </Box>
                                <Divider style={{ margin: '15px 0', borderColor: darkMode ? '#333' : '#eee' }} />
                                <div style={{ height: 600, width: '100%' }}>
                                    <DataGrid
                                        rows={logs}
                                        columns={logColumns}
                                        getRowId={(row) => row.id_log_ronda_motorizada}
                                        pagination
                                        pageSize={10}
                                        rowsPerPageOptions={[10, 25, 50]}
                                        components={{
                                            Toolbar: CustomToolbar,
                                        }}
                                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                        style={{ 
                                            border: 'none',
                                            color: darkMode ? '#fff' : 'inherit',
                                        }}
                                    />
                                </div>
                            </Paper>
                        )}
                    </Container>
                </main>

                <Dialog open={openCancelarProcedimento} onClose={handleCloseCancelarProcedimento} maxWidth="sm" fullWidth PaperProps={{ style: { backgroundColor: darkMode ? '#1e1e1e' : '#fff', color: darkMode ? '#fff' : 'inherit' } }}>
                    <DialogTitle style={{ fontWeight: 700 }}>Cancelar Procedimento</DialogTitle>
                    <DialogContent>
                        <Typography variant="body2" color="textSecondary" gutterBottom>
                            Por favor, descreva o motivo pelo qual este procedimento não pôde ser realizado.
                        </Typography>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Justificativa"
                            fullWidth
                            variant="outlined"
                            multiline
                            rows={4}
                            value={mensagemCancelamento}
                            onChange={(e) => setMensagemCancelamento(e.target.value)}
                            InputProps={{ style: { color: darkMode ? '#fff' : 'inherit' } }}
                            style={{ marginTop: 15 }}
                        />
                        <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
                            <Button onClick={handleCloseCancelarProcedimento} style={{ color: darkMode ? '#aaa' : 'inherit' }}>Voltar</Button>
                            <Button onClick={handleClickCancelarProcedimento} color="error" variant="contained" style={{ borderRadius: 8 }}>Confirmar Cancelamento</Button>
                        </Box>
                    </DialogContent>
                </Dialog>

                <Dialog open={openTratamentoRemoto} onClose={handleCloseTratamentoRemoto} maxWidth="md" fullWidth PaperProps={{ style: { backgroundColor: darkMode ? '#1e1e1e' : '#fff', color: darkMode ? '#fff' : 'inherit', borderRadius: 15 } }}>
                    <DialogTitle style={{ fontWeight: 800, fontSize: 22 }}>Encerramento da Ronda Motorizada</DialogTitle>
                    <DialogContent>
                        <Typography variant="body2" gutterBottom color="textSecondary">Insira as observações finais para o encerramento desta ronda.</Typography>
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            variant="outlined"
                            placeholder="Descreva o desfecho da ronda, problemas encontrados ou resoluções..."
                            value={observacoesEncerramentoRonda}
                            onChange={(e) => setObservacoesEncerramentoRonda(e.target.value)}
                            style={{ marginTop: 15 }}
                            InputProps={{ style: { color: darkMode ? '#fff' : 'inherit' } }}
                        />
                        
                        <Box mt={3} p={3} style={{ backgroundColor: darkMode ? '#222' : '#f9f9f9', borderRadius: 12, border: darkMode ? '1px solid #333' : '1px solid #eee' }}>
                            <FormControlLabel
                                control={<Checkbox checked={criarOrdemServico} disabled={disableOpcaoOrdemServico} onChange={(e) => setCriarOrdemServico(e.target.checked)} color="primary" />}
                                label={<Typography style={{ fontWeight: 600 }}>Gerar Ordem de Serviço Corretiva automaticamente?</Typography>}
                            />
                            {disableOpcaoOrdemServico && (
                                <Typography variant="caption" color="error" style={{ display: 'block', marginLeft: 30, fontWeight: 500 }}>
                                    * Esta opção está bloqueada porque existem problemas relatados que exigem manutenção.
                                </Typography>
                            )}
                        </Box>

                        <Box mt={4} display="flex" justifyContent="flex-end" gap={2} pb={2}>
                            <Button onClick={handleCloseTratamentoRemoto} style={{ color: darkMode ? '#aaa' : 'inherit' }}>Descartar</Button>
                            <Button 
                                onClick={handleFinalizarRondaMotorizada} 
                                variant="contained" 
                                color="success"
                                disabled={inSalvamento}
                                startIcon={inSalvamento ? <RefreshIcon className="animate-spin" /> : <CheckCircleIcon />}
                                style={{ borderRadius: 10, padding: '10px 25px', fontWeight: 700 }}
                            >
                                {inSalvamento ? "Salvando..." : "Salvar e Finalizar Ronda"}
                            </Button>
                        </Box>
                    </DialogContent>
                </Dialog>
            </div>
        </ThemeProvider>
    );
}
